import {getPartnerDetails} from "./getPartnerDetails";

export const getPartnerKey = () => {
  const partnerDetails = getPartnerDetails();
  return partnerDetails.partnerKey;
};
